import { FC } from 'react'

import AcquiringTabs from 'components/core/Acquiring/AcquiringTabs'
import { usePermissions } from 'hooks/usePermissions'
import { useAppSelector } from 'redux/hooks'

import { COMPONENT_EXTENDER } from 'extender'

const PaymentGatewayWizard = COMPONENT_EXTENDER('components/core/Wizard/PaymentGatewayWizard')
const HomePageLayout = COMPONENT_EXTENDER('components/layouts/HomePageLayout')

const AcquiringPage: FC = () => {
    const { getPermission } = usePermissions()

    const { cardAcquiringMerchantsInit } = useAppSelector(state => state.acquiring)

    return (
        <HomePageLayout>
            {getPermission('CanRegisterForPaymentGateway') ? (
                <PaymentGatewayWizard />
            ) : (
                <AcquiringTabs currentValue={cardAcquiringMerchantsInit ? 3 : 0} />
            )}
        </HomePageLayout>
    )
}

export default AcquiringPage
